import localForage from "localforage"
import crypto from "crypto"
import {Mutex} from "async-mutex"

const BASE_URL = process.env.AUTH_SERVICE_URL
const STORE_KEY = "auth"

class Storage {
  constructor(){
    this.secret = null
    this.items = {}
    this.mutex = new Mutex()
  }

  setItem(key, value){
    this.items[key] = value
    this.store()
  }

  getItem(key){
    return this.items[key]
  }

  removeItem(key){
    delete this.items[key]
    this.store()
  }

  clear(){
    this.items = {}
    this.store()
  }

  replace(items){
    this.items = items
    this.store()
  }

  async sync(){
    await this.mutex.runExclusive(async () => {
      console.debug("[auth_ui] sync")
      this.secret = await this.getSecret()
      await this.restore()
    })
  }

  store(){
    if(!this.secret) return

    console.debug("[auth_ui] store")
    const val = enc(JSON.stringify(this.items), this.secret)
    localForage.setItem(STORE_KEY, val)
  }

  async restore(){
    if(!this.secret) return

    console.debug("[auth_ui] restore")
    try{
      const val = await localForage.getItem(STORE_KEY)
      const decrypted = dec(val, this.secret)
      this.items = JSON.parse(decrypted)
    }
    catch(e){
      console.warn("auth_ui storage restore catch", e)
    }
  }

  async getSecret(){
    if(this.secret) return this.secret

    if(process.env.APP_ENV === "local-development") return "local"
    try {
      const res = await fetch(BASE_URL+"/key", {credentials: "include"})
      return res.text()
    }
    catch(e){
      console.warn("storage getSecret catch", e)
    }
  }
}


const ENC_ALGORITHM = "aes-256-cbc"

function enc(str, enckey){
  const cipher = crypto.createCipher(ENC_ALGORITHM, enckey)
  return cipher.update(str, "utf8", "hex") + cipher.final("hex")
}

function dec(str, enckey){
  const decipher = crypto.createDecipher(ENC_ALGORITHM, enckey)
  return decipher.update(str, "hex", "utf8") + decipher.final("utf8")
}

export default new Storage()
